import store from '@/stores';
import { accountsAPI } from '@/services';

// same role ids as src/mixins/roleManager.mixin.js's isAdmin/isSuper/isCommercial/isSuperIntendent
const ADMIN_ROLE_ID = 1;
const SUPER_ROLE_ID = 6;
const COMMERCIAL_ROLE_ID = 11;
const SUPERINTENDENT_ROLE_ID = 17;

export function canAccessPromoterDetails({ userInfo, promoter }) {
  const roles = userInfo?.roles_ids || [];
  const userId = userInfo?.id;

  return [
    roles.includes(SUPER_ROLE_ID),
    roles.includes(ADMIN_ROLE_ID),
    roles.includes(COMMERCIAL_ROLE_ID) && promoter?.commercial_id === userId,
    roles.includes(SUPERINTENDENT_ROLE_ID) && promoter?.superintendent_id === userId,
  ].some((isValid) => isValid);
}

// On a hard navigation this guard runs before App.vue's verifyDataUser.mixin
// mounted() hook fetches /users/me, so userInfo is still {} here — fetch it
// ourselves rather than trust the store to already have it.
async function getLoadedUserInfo() {
  if (store.state.user.userInfo?.id) return store.state.user.userInfo;

  const { data } = await accountsAPI.getInfoUser();
  store.dispatch('user/SET_USER_DATA', data);

  return data;
}

export async function promoterDetailsBeforeEnter(to, from, next) {
  const fallback = from.name ? { name: from.name } : { name: 'promoters' };

  try {
    const [userInfo, { data }] = await Promise.all([
      getLoadedUserInfo(),
      accountsAPI.getPromoters(to.params.id),
    ]);

    if (canAccessPromoterDetails({ userInfo, promoter: data.data })) next();
    else next(fallback);
  } catch {
    next(fallback);
  }
}
